import { Routes, Route, Navigate } from "react-router-dom";
import { OrbitAuthProvider } from "@/orbit/context/AuthContext";
import ProtectedRoute from "@/orbit/components/ProtectedRoute";
import AppShell from "@/orbit/components/AppShell";
import Login from "@/orbit/pages/Login";
import Register from "@/orbit/pages/Register";
import ForgotPassword from "@/orbit/pages/ForgotPassword";
import ResetPassword from "@/orbit/pages/ResetPassword";
import AcceptInvite from "@/orbit/pages/AcceptInvite";
import Dashboard from "@/orbit/pages/Dashboard";
import Settings from "@/orbit/pages/Settings";

export default function OrbitApp() {
  return (
    <OrbitAuthProvider>
      <Routes>
        <Route path="/" element={<Navigate to="/orbit/login" replace />} />
        <Route path="login" element={<Login />} />
        <Route path="register" element={<Register />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="reset-password/:token" element={<ResetPassword />} />
        <Route path="accept-invite/:token" element={<AcceptInvite />} />
        <Route path="app" element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="settings" element={<Settings />} />
          <Route path="*" element={<Navigate to="dashboard" replace />} />
        </Route>
        <Route path="*" element={<Navigate to="/orbit/login" replace />} />
      </Routes>
    </OrbitAuthProvider>
  );
}
